import ScrollMagic from 'scrollmagic';

$(() => {
    const controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '.l-page__header',
        triggerHook: 0.95,
        reverse: false
    })
    .setClassToggle('.l-page__header .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page-contacts__individual',
        triggerHook: 0.95,
        reverse: false
    })
    .setClassToggle('.l-page-contacts__individual .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__get-now',
        triggerHook: 0.95,
        reverse: false
    })
    .setClassToggle('.l-page__get-now .js-animate', 'js-animate-loaded')
    .addTo(controller);

});



// WEBPACK FOOTER //
// ./app/scripts/pages/support.js